import React from 'react';
import { Button, Icon, Image } from 'semantic-ui-react';
import { Box, Flex } from 'rebass';

import { Text } from '../Base';

export const EmptyView = ({
  text = 'คุณยังไม่ได้เลือกคณะในดวงใจ',
  image = '/emptyChooseFav.png',
}) => {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Box style={{ maxWidth: 240 }}>
        <Image src={image} />
      </Box>
      <Text color="greyscale.grey4" fontSize={3} textAlign="center" pt={1}>
        {text}
      </Text>
    </Flex>
  );
};

export default EmptyView;
